/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- ADD-ON TYPES RATINGS COUNTER LABEL: STYLES --------------- ++++++++++ */
export default theme => ({
  ratingscountlabel: {
    marginTop: pxToEm(16),
    '& .fields': {
      display: 'inline-flex',
      width: '100%',
      '& .fielditem': {
        width: '50%',
        marginRight: pxToEm(8),
        '& label': {
          display: 'flex',
          height: pxToEm(24),
          lineHeight: pxToEm(24),
          fontSize: pxToEm(14)
        },
        '& .field': {
          marginTop: pxToEm(8),
          width: '100%'
        }
      }
    }
  },

  // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
  [mediaQuery.thinnest]: {
    ratingscountlabel: {
      '& .fields': {
        width: '100%',
        flexDirection: 'column',
        '& .fielditem': {
          width: '100%',
          paddingBottom: pxToEm(16)
        }
      }
    }
  }
});
